import { ClinicalRelationships } from '../../../../constants';
import { PROVIDER_ASSIGNMENTS_BASE_URL } from '../../../../constants/services';
import { fetchWrapper } from '../../../../helpers';

import type { IProviderAssignment } from '../../../../utils/types';

interface FetchClientProviderAssignmentsParams {
  clientId: number;
  getAccessTokenSilently: () => Promise<string>;
  activeOnly?: boolean;
}

export async function fetchClientProviderAssignments(
  params: FetchClientProviderAssignmentsParams,
): Promise<IProviderAssignment[]> {
  const { clientId, getAccessTokenSilently, activeOnly = true } = params;
  const searchParams = new URLSearchParams({
    active_only: String(activeOnly),
    client_id: String(clientId),
  });
  const url = `${PROVIDER_ASSIGNMENTS_BASE_URL}/?${searchParams.toString()}`;
  const data = await fetchWrapper.get({ url, getAccessTokenSilently });
  return data;
}

export async function fetchGuardianProviderAssignments(
  clientId: number,
  getAccessTokenSilently: () => Promise<string>,
): Promise<IProviderAssignment[]> {
  const url = `${PROVIDER_ASSIGNMENTS_BASE_URL}/?client_id=${clientId}&clinical_relationship=${ClinicalRelationships.PracticingGuardian}`;
  const data = await fetchWrapper.get({ url, getAccessTokenSilently });
  return data;
}
